var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format, options) {
  const defaultDelimiter = options?.delimiter ?? ",";
  const withCurrency = options?.withCurrency ?? true;
  const currency = Shopify?.currency?.active;

  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }

  function formatWithDelimiters(
    number,
    precision = 2,
    delimiter = defaultDelimiter,
    decimal = ".",
  ) {
    let amount = number / 100;
    amount = amount.toFixed(2);
    amount = Number(amount);

    let formatter;
    if (Shopify.currency.active === "JPY") {
      formatter = new Intl.NumberFormat("ja-JP", {
        style: "currency",
        currency: "JPY",
        currencyDisplay: "symbol",
        precision,
        delimiter,
        decimal,
      });
    } else if (Shopify.currency.active === "USD") {
      formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        currencyDisplay: "symbol",
        precision,
        delimiter,
        decimal,
      });
    }

    const result = toHalfWidth(formatter.format(amount)).replaceAll(
      ",",
      delimiter,
    );
    if (withCurrency) {
      return `${result} ${currency}`;
    }

    return result;
  }

  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || this.money_format;
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return toHalfWidth(formatString.replace(placeholderRegex, value));
};

const toHalfWidth = (str) => {
  const result = str
    .replace(/[！-～]/g, (tmp) => {
      return String.fromCharCode(tmp.charCodeAt(0) - 0xfee0);
    })
    .replace("￥", "¥");

  return result;
};
